<!-- 失效流量包 -->
<template>
  <div class="order invalidFlow">
    <div class="order-header">
      <app-header @on-click="e_goBack"
        backgroundColor="#F2F2F2"
        :title="$t('invalidFlow.pageName')"></app-header>
    </div>
    <div class="order-data">
      <div class="order-con">
        <div class="order-con-flow invalidColor"
          v-if="firstInFlag && dataList.length">
          <div class="flowCon">
            <ul class="flowItem"
              :class="{'van-hairline--top': index != 0}"
              v-for="(item, index) in dataList"
              :key="index">
              <li class="title">{{item.goodsName}}</li>
              <li class="flowCount" v-if="item.a_surplusFlowbyte && (!item.extendValVos || !item.a_getValue_hideFlowSize || item.a_getValue_hideFlowSize && item.a_getValue_hideFlowSize != '1')">{{$t('order.remainingFlow')}}：{{item.a_surplusFlowbyte | filterFlow}}</li>
              <li class="timeLimit">{{$t('invalidFlow.stateName')}}：{{item.status && $t("invalidFlow.state." + item.status)}}</li>
            </ul>
          </div>
        </div>
        <div class="order-con-none"
          v-if="firstInFlag && !dataList.length">
          <div class="title">{{$t('invalidFlow.noneFlow')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cookie from "../../utils/cookie";
import { keepTwodecimalFixed } from "../../utils/util";
import checkProjectConfig from '@/lib/checkProjectConfig';
export default {
  name: "invalidFlow",
  data() {
    return {
      dataList: [],
      firstInFlag: false
    };
  },
  methods: {
    getInvalidOrderList() {
      let data = {
            flag: 1,
            goodsType: "ALL",
            queryNoUse: true,
            goodsExtendAttrs:["hideFlowSize"],
            customerId: this._urlData['loginCustomerId']
      }
      if(sessionStorage.getItem('Module_Bind_Group') === 'true'){
        data = {
          ...data,
          imei:this._urlData?.imei
        }
      }
      this.$http
        .post({
          url: "/bss/app/orderRelation/QueryUserOfferList",
          data: {
              ...data
          }
        })
        .then(da => {
          let codeList = checkProjectConfig.setAppThat(this).checkValue("Test_Package_Codes",[]);
          if(codeList && codeList.length){
            let dataList = (da?.data?.dataList || []).filter(item => {
              return !codeList.includes(item.goodsCode);
            })
            this.dataList = this.disposalData(dataList);
          } else {
            this.dataList = this.disposalData(da && da.data && da.data.dataList);
          }
        })
        .finally(() => {
          this.firstInFlag = true;
        });
    },
    //整理数据结构
    disposalData(dataList = []) {
      dataList.forEach(item => {
        //流量包
        if (item.goodsType == "PKAG") {
          item.a_surplusFlowbyte = item.surplusFlowbyte;
        }
        //优惠销售品
        if (item.goodsType == "DISC") {
          let da = item.accumulatedFlowList;
          da = (da && da[0]) || { totalFlow: "", accumulatedFlow: "" };
          let calculateFlow = this._math.sub(da.totalFlow, da.accumulatedFlow);
          item.a_surplusFlowbyte = calculateFlow > 0 ? calculateFlow : 0;
        }

        goodsExtendAttrs(item,item);
      });

      //查询的销售品扩展属性列表
      function goodsExtendAttrs(item,{extendValVos}) {
        
        if(extendValVos && extendValVos.length){
            extendValVos.forEach( _goodsExtendAttrsItem => {  
                // 获取 attrValueList 数组  
                const attrValueList = _goodsExtendAttrsItem.attrValueList;  
                  
                // 判断attrValueList数组并获取值  
                const getValue= attrValueList && attrValueList[0];

                //a_hideFlowSize
                item['a_'+_goodsExtendAttrsItem.attrCode] = attrValueList;

                //a_getValue_hideFlowSize
                item['a_getValue_'+_goodsExtendAttrsItem.attrCode] = getValue;
            });
            
        }
      }
      return dataList;
    },
    e_goBack() {
      this.$router.go(-1);
    },
    _math() {
      const add = (arg1, arg2) => {
        var r1, r2, m;
        try {
          r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
          r1 = 0;
        }
        try {
          r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
          r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        return (arg1 * m + arg2 * m) / m;
      };
      const sub = (arg1, arg2) => {
        return add(arg1, -arg2);
      };
      return {
        add,
        sub
      };
    }
  },
  filters: {
    filterFlow(da) {
      if (da == 0) return "0MB";
      if (!da) return "";
      let flow = keepTwodecimalFixed(da < 1000 ? da : da / 1024);
      let langType = cookie.getCookie('langType')
      // 部分欧洲国家小数点采取 ， 形式
      let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
      let showFlow = flow.toString().replace(/\.00$|0$/, "")
      if(country.includes(langType)){
          showFlow = showFlow.replace('.',',')
      }
      return `${showFlow}${(da < 1000 && "MB") || "GB"}`;
    }
  },
  created(){
    this._urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
  },
  mounted() {
    this.getInvalidOrderList();
    this._math = this._math();
  }
};
</script>

<style lang="less" scoped>
@import "css/index.less";
.invalidFlow {
  background-color: #f2f2f2 !important;
}
.order .order-data {
  padding-top: 34px;
}
.order .order-data .order-con .order-con-flow.invalidColor {
  color: #999999;
}
</style>